import React, { useContext } from "react";
import { UserContext } from "./Auth/UserContextProvider";

const AdminDiv = (props) => {
  const { isAdmin } = useContext(UserContext);
  return <div>{isAdmin && <div {...props}></div>}</div>;
};

export default AdminDiv;
